import { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/freeGuide.css";

const FreeGuideThankYou = () => {
  useEffect(() => {
    document.title = "You're in! Disciplined Me";
  }, []);

  return (
    <div className="site-page page-free-guide">
      <nav><div className="wrap"><div className="logo">disciplined<span>.me</span></div><Link to="/" className="nav-back">← Back home</Link></div></nav>

      <section className="hero">
        <div className="wrap">
          <div className="thankyou-card">
            <div className="thankyou-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            <h1 style={{ fontSize: "28px" }}>You're in! Your guide is ready.</h1>
            <p className="hero-sub" style={{ marginTop: "10px", marginBottom: "6px" }}>
              We've also sent a confirmation to your inbox with the PDF attached.
            </p>
            <a
              href="/files/free-guide-7-ai-prompts.pdf"
              download="Disciplined-Me-7-AI-Prompts.pdf"
              className="download-btn"
            >
              ⬇ Download "7 AI Prompts That Build Discipline"
            </a>
          </div>
        </div>
      </section>

      <section className="cta2">
        <div className="wrap">
          <h2>Ready to go deeper?</h2>
          <p>The free guide is your starting toolkit. The full bundle is the complete 30-day system.</p>
          <Link to="/bundle" className="btn-primary">See the full bundle, CHF 29</Link>
        </div>
      </section>

      <footer>© Disciplined Me, Building the identity of someone who keeps going.</footer>
    </div>
  );
};

export default FreeGuideThankYou;
